import { render, staticRenderFns } from "./paginatedWkExportResourceList.vue?vue&type=template&id=a0959960"
import script from "./paginatedWkExportResourceList.vue?vue&type=script&lang=ts"
export * from "./paginatedWkExportResourceList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports